// **Third Party Imports
import axios from 'axios'

// **Utils Imports
import { API_URL } from '../env/env'
import { ERROR_500 } from '../utils/constant'
import {
  checkCandidateAccess,
  checkDeveloperAccess,
  getJWTToken,
  getUserWorkspaceId,
  handleRedirectPathSession,
  logoutUser,
  setUserWorkspaceId
} from '../utils/utils'

axios.defaults.baseURL = API_URL

axios.interceptors.request.use(
  (config) => {
    const accessToken = getJWTToken()

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    if (config.checkWorkspaceId) {
      config.headers['X-Check-Workspace-Id'] = config.checkWorkspaceId // Or any header name
    }

    return config
  },
  (error) => ({
    isError: true,
    status: error?.response?.status || 500,
    message: !window?.navigator?.onLine
      ? 'You are offline'
      : error?.response?.data || ERROR_500
  })
)

axios.interceptors.response.use(
  (response) => {
    const checkWorkspaceId =
      response?.config?.headers?.['X-Check-Workspace-Id'] || null
    if (checkWorkspaceId) {
      const workspaceId = getUserWorkspaceId()
      if (response?.data?.workspaceId) {
        const isDeveloper = checkDeveloperAccess()
        if (
          response?.data?.workspaceId !==
            (workspaceId ? parseInt(workspaceId) : null) &&
          !isDeveloper
        ) {
          setUserWorkspaceId(response?.data?.workspaceId)
          window.location.reload()
        }
      }
    }
    return response?.data
  },
  (error) => {
    if (axios?.isCancel(error)) {
      return
    }

    if (error.response && error.response.status === 401) {
      const currentPath = window?.location?.pathname + window?.location?.search

      if (currentPath !== '/' && !checkCandidateAccess()) {
        handleRedirectPathSession(currentPath)
      }

      logoutUser()
      return
    } else if (error.response && error.response.status === 403) {
      const currentPath = window.location.pathname?.toLowerCase()

      if (currentPath !== '/c' && currentPath !== '/') {
        window.location.href =
          currentPath === '/c' || currentPath?.startsWith('/c/')
            ? `${window.location.origin}/c?unAuthorised=true`
            : `${window.location.origin}?unAuthorised=true`
      }

      return
    }

    return {
      isError: true,
      status: error?.response?.status || 500,
      message: !window?.navigator?.onLine
        ? 'You are offline'
        : error?.response?.data || ERROR_500
    }
  }
)

export default axios
